/**
 * ID For Mouseflow
 */
export const MOUSEFLOW_APP_ID = 'a052e0a6-b615-49c8-9357-37e9fefe45c2';
